// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Fiji */
const FJ = /^(?:(?:[279]\d|45|5[01568]|8[034679])\d{5})$/;

export default FJ;
